import { Box, Grid, Paper, Typography } from '@mui/material';
import React from 'react';
import { ButtonDefault } from '../../shared/components/ButtonDefault';
import { useNavigate } from 'react-router-dom';

export const AuthInactive: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Box style={{ width: '100%', height: '100vh' }}>
      <Grid container justifyContent='center' alignItems='center' height='100%'>
        <Grid item xs={12} md={3}>
          <Paper elevation={3}>
            <Box height={200} p={2} display='flex' flexDirection='column' alignItems='center' justifyContent='center'>
              <Typography variant='h5' mb={1} textAlign='center'>
                Your account is currently waiting for approval to access the platform.
              </Typography>
              <Box display='flex' alignItems='center' justifyContent='center'>
                <Box mr={1}>
                  <ButtonDefault variant='outlined' onClick={() => navigate('/')}>
                    Refresh
                  </ButtonDefault>
                </Box>
                <Box>
                  <ButtonDefault variant='contained' onClick={() => navigate('/logout')}>
                    Log out
                  </ButtonDefault>
                </Box>
              </Box>

            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};